export type GameRestartedPayloadLike = {
  newGameId?: unknown;
  currentRoundId?: unknown;
};

export type ClassifiedGameRestartedPayload =
  | {
      kind: 'supported-same-room';
      requestedRoomId: string;
      currentRoundId: string;
    }
  | {
      kind: 'legacy-read-only';
      requestedRoomId: string;
      currentRoundId: string | null;
    }
  | {
      kind: 'invalid';
      requestedRoomId: null;
      currentRoundId: null;
    };

export function classifyGameRestartedPayload(
  currentRoomId: string,
  payload: GameRestartedPayloadLike,
): ClassifiedGameRestartedPayload {
  const requestedRoomId = typeof payload.newGameId === 'string' ? payload.newGameId.trim() : '';
  if (!requestedRoomId) {
    return {
      kind: 'invalid',
      requestedRoomId: null,
      currentRoundId: null,
    };
  }

  const currentRoundId = typeof payload.currentRoundId === 'string' && payload.currentRoundId.trim().length > 0
    ? payload.currentRoundId.trim()
    : null;

  if (requestedRoomId === currentRoomId && currentRoundId) {
    return {
      kind: 'supported-same-room',
      requestedRoomId,
      currentRoundId,
    };
  }

  return {
    kind: 'legacy-read-only',
    requestedRoomId,
    currentRoundId,
  };
}